import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';
import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormView } from '@form/cer-form-view';


export class FormRecogizerForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {

    viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 70);

    const doc = this.viewDocGet()
    const lines = this.viewLinesGet()
    viewSet.viewAdd(doc);
    viewSet.viewAdd(lines, doc);
  }

  private viewDocGet() : CerFormView {
    var viewDoc = new CerFormView();
    viewDoc.paneTarget = 'main';
    viewDoc.viewMetadata = {
      name: 'formulargenkendelser', dataApiName: 'FormRecognizer', text: 'Opsætninger', textSingular: 'Opsætning',
      primaryKey: 'id', titleFields: ['name'], baseFields: ['id', 'history']
    };
    viewDoc.fieldMetadata = [
      { name: 'name', text: 'Navn', tooltipText: 'Navn', required: true, widthType: FieldWidthEnum.M },
      { name: 'type', text: 'Genkendelsestype', tooltipText: 'Reference til bagvedlæggende genkendelse', widthType: FieldWidthEnum.M, foreignKeyTableName: 'FormRecognizerType' }
    ];
    return viewDoc;
  }

  private viewLinesGet() : CerFormView {
    var viewLines = new CerFormView();
    viewLines.mandatory = true;
    
    viewLines.viewMetadata = {
      name: 'formulargenkendelse-felter', dataApiName: 'FormRecognizerField', text: 'Felter', textSingular: 'Felt',
      primaryKey: 'id', parentPrimaryKey: 'id', parentForeignKey: 'formRecognizer', titleFields: ['key'], baseFields: ['id', 'history']
    };
    viewLines.fieldMetadata = [
      { name: 'type', text: 'Felt', tooltipText: 'Grundlæggende felt', widthType: FieldWidthEnum.S, foreignKeyTableName: 'FormRecognizerFieldType', orderBy: 'Ascending' },
      { name: 'key', text: 'Søgenøgle udtryk', tooltipText: '', widthType: FieldWidthEnum.M },
      { name: 'value', text: 'Værdi udtryk', tooltipText: '', widthType: FieldWidthEnum.M },
      { name: 'replaceFrom', text: 'Erstat fra', tooltipText: '', widthType: FieldWidthEnum.M },
      { name: 'replaceTo', text: 'Erstat med', tooltipText: '', widthType: FieldWidthEnum.M },
      { name: 'format', text: 'Datoformat', tooltipText: 'Datoformat (se https://docs.microsoft.com/en-us/dotnet/standard/base-types/formatting-types)', widthType: FieldWidthEnum.S, visible: false, visibleEdit: true },
      { name: 'culture', text: 'Landeformat', tooltipText: 'F.eks. for US engelsk brug "en-us" eller dansk "da"', widthType: FieldWidthEnum.S, visible: false, visibleEdit: true },
      { name: 'valueNext', text: 'Næste værdi', tooltipText: '', widthType: FieldWidthEnum.XS, format: 'CheckBox' },
      { name: 'valueConstant', text: 'Konstant værdi', tooltipText: 'Nøgle bruges ikke', widthType: FieldWidthEnum.XS, format: 'CheckBox' },
      { name: 'keyValuePair', text: 'Nøgle+værdi sæt', tooltipText: '', widthType: FieldWidthEnum.XS, format: 'CheckBox' },
    ];
    return viewLines;
  }
}
